import { APIcaller } from '@commons/utils/APICaller';

import { Client } from '@commons/types/clients';

const findAssociatedClients = async (): Promise<[Client]> => APIcaller.apiGet('clients');

export default {
  findAssociatedClients
};
